import { LoruleRequestConfig } from '@galaxy/lorule-react-commons';
import { callWebUtils, commonHeaders } from './commonApiUtil';
import {
    ProjectBalance,
    PendingProjectCommitmentItem,
    ProjectCommitmentItem,
    ProjectActualItem,
    ProjectCommitmentSearch,
    ProjectActualSearch,
    InvoiceHeader,
    InvoiceDistribution,
} from './projectBalanceApiTypes';

export const getProjectBalance = async (
    config: LoruleRequestConfig,
    amId: number,
    user: boolean = true,
) =>
    callWebUtils<ProjectBalance>(
        config,
        `/actionmemo/${amId}/projectbalance?user=${user}`,
        'GET',
        null,
        commonHeaders,
    );

export const getPendingProjectCommitments = async (
    config: LoruleRequestConfig,
    amId: number,
    user: boolean = true,
) =>
    callWebUtils<Array<PendingProjectCommitmentItem>>(
        config,
        `/actionmemo/${amId}/projectbalance/fundscheckcommitment?user=${user}`,
        'GET',
        null,
        commonHeaders,
    );

export const getProjectCommitments = async (
    config: LoruleRequestConfig,
    amId: number,
    search?: ProjectCommitmentSearch | null,
    pageSize?: number | null,
    pageIndex?: number | null,
    sortBy?: string | null,
    desc?: boolean | null,
    user: boolean = true,
) => {
    let queryString = '';
    if (search) {
        const { textSearchValues, sources, dateFrom, dateTo, vendorNames } = search;
        if (textSearchValues && textSearchValues.length > 0) {
            queryString += textSearchValues.reduce(
                (previousValue, currentValue) => `${previousValue}&textSearch=${currentValue}`,
                '',
            );
        }
        if (sources && sources.length > 0) {
            queryString += sources.reduce(
                (previousValue, currentValue) => `${previousValue}&source=${currentValue}`,
                '',
            );
        }
        if (dateFrom) queryString += `&dateFrom=${dateFrom}`;
        if (dateTo) queryString += `&dateTo=${dateTo}`;
        if (vendorNames && vendorNames.length > 0) {
            queryString += vendorNames.reduce(
                (previousValue, currentValue) => `${previousValue}&vendorName=${currentValue}`,
                '',
            );
        }
    }
    if (sortBy) queryString += `&sortBy=${sortBy}`;
    if (desc) queryString += `&desc=${desc}`;
    if (pageIndex) queryString += `&pageIndex=${pageIndex}`;
    if (pageSize) queryString += `&pageSize=${pageSize}`;
    return callWebUtils<Array<ProjectCommitmentItem>>(
        config,
        `/actionmemo/${amId}/projectbalance/commitment?user=${user}${queryString}`,
        'GET',
        null,
        commonHeaders,
    );
};

export const getProjectActuals = async (
    config: LoruleRequestConfig,
    amId: number,
    search?: ProjectActualSearch | null,
    pageSize?: number | null,
    pageIndex?: number | null,
    sortBy?: string | null,
    desc?: boolean | null,
    user: boolean = true,
) => {
    let queryString = '';
    if (search) {
        const { textSearchValues, sources, dateFrom, dateTo } = search;
        if (textSearchValues && textSearchValues.length > 0) {
            queryString += textSearchValues.reduce(
                (previousValue, currentValue) => `${previousValue}&textSearch=${currentValue}`,
                '',
            );
        }
        if (sources && sources.length > 0) {
            queryString += sources.reduce(
                (previousValue, currentValue) => `${previousValue}&source=${currentValue}`,
                '',
            );
        }
        if (dateFrom) queryString += `&dateFrom=${dateFrom}`;
        if (dateTo) queryString += `&dateTo=${dateTo}`;
    }
    if (sortBy) queryString += `&sortBy=${sortBy}`;
    if (desc) queryString += `&desc=${desc}`;
    if (pageIndex) queryString += `&pageIndex=${pageIndex}`;
    if (pageSize) queryString += `&pageSize=${pageSize}`;
    return callWebUtils<Array<ProjectActualItem>>(
        config,
        `/actionmemo/${amId}/projectbalance/actual?user=${user}${queryString}`,
        'GET',
        null,
        commonHeaders,
    );
};

export const getProjectInvoice = async (
    config: LoruleRequestConfig,
    amId: number,
    invoiceId: number,
    commitment: boolean,
    user: boolean = true,
) =>
    callWebUtils<InvoiceHeader>(
        config,
        `/actionmemo/${amId}/projectbalance/${
            commitment ? 'commitment' : 'actual'
        }/invoice/${invoiceId}?user=${user}`,
        'GET',
        null,
        commonHeaders,
    );

export const getProjectInvoiceDistributions = async (
    config: LoruleRequestConfig,
    amId: number,
    invoiceId: number,
    invoiceLineNumber: number,
    commitment: boolean,
    user: boolean = true,
) =>
    callWebUtils<Array<InvoiceDistribution>>(
        config,
        `/actionmemo/${amId}/projectbalance/${
            commitment ? 'commitment' : 'actual'
        }/invoice/${invoiceId}/line/${invoiceLineNumber}/distribution?user=${user}`,
        'GET',
        null,
        commonHeaders,
    );
